import { parse } from "date-fns";

const checkIfTicketForSale = (ticket, eventStatus) => {
    parse(ticket.acf.ticket_available_from, "yyyy-MM-dd KK:mm:ss", new Date());
    const currentDate = new Date();
    const ticketDateAvailability = ticket.acf
        ? currentDate >=
              parse(
                  ticket.acf.ticket_available_from,
                  "yyyy-MM-dd H:mm:ss",
                  new Date()
              ) &&
          currentDate <=
              parse(
                  ticket.acf.ticket_available_until,
                  "yyyy-MM-dd H:mm:ss",
                  new Date()
              )
        : true;

    const ticketIsUnavailable =
        eventStatus === "cancelled" ||
        ticket.stock_status !== "instock" ||
        !ticketDateAvailability
            ? true
            : false;

    return !ticketIsUnavailable;
};

export default checkIfTicketForSale;
